// @flow
export { default } from './SectionsTemplate';



// WEBPACK FOOTER //
// ./src/components/sections/SectionsTemplate/index.js